import React from 'react';
import { formatTimeFromSeconds } from '../utils/methods/dateTime';

const useCountdownTimer = ({ seconds }) => {
  // static data start...
  const countdownInit = React.useMemo(() => {
    return {
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }, []);
  // static data end...

  // useState variables start...
  const [totalSeconds, setTotalSeconds] = React.useState(seconds);
  const [countDown, setCountDown] = React.useState(countdownInit);
  const [isInitialised, setIsInitialised] = React.useState(false);
  // useState variables end...

  // useEffect start...
  React.useEffect(() => {
    setTotalSeconds(seconds);
  }, [seconds]);

  React.useEffect(() => {
    if (typeof totalSeconds !== 'number') {
      return;
    }

    if (totalSeconds < 0) {
      return;
    }

    const timerId = setTimeout(() => {
      const { hours, minutes, seconds } = formatTimeFromSeconds(totalSeconds);

      setCountDown((countDown) => {
        return {
          ...countDown,
          hours,
          minutes,
          seconds,
        };
      });

      setTotalSeconds(totalSeconds => totalSeconds - 1);
      setIsInitialised(true);
    }, 1000);

    return () => {
      clearTimeout(timerId);
    };
  }, [totalSeconds]);
  // useEffect end...

  return {
    countDown,
    isInitialised
  };
};

export { useCountdownTimer };
